import { Route } from 'react-router';
import { CommunityManagementPage } from './CommunityManagementPage';
import { CommunityFeedPage } from './CommunityFeedPage';
import { CommunityNoCareMapPage } from './CommunityNoCareMapPage';

export const CommunityRouteHandler: React.FC = () => (
    <>
        <Route exact path="/community/:caremapId/feed" render={routeParams => {
            const caremapId = routeParams.match.params.caremapId;
            return caremapId === 'undefined'
                ? <CommunityNoCareMapPage />
                : <CommunityFeedPage careMapId={caremapId} />
            ;
        }} />

        <Route exact path="/community/:caremapId" render={routeParams => (
            <CommunityManagementPage careMapId={routeParams.match.params.caremapId} />
        )} />
    </>
);
